<div [formGroup]="questionFormGroup" fxLayoutGap="1rem" fxLayout="column">
    <mat-form-field>
        <mat-label>Question</mat-label>
        <input formControlName="value" name="value" matInput>
    </mat-form-field>

    <mat-form-field>
        <mat-label>Additional Info</mat-label>
        <input formControlName="description" name="description" matInput>
    </mat-form-field>

    <mat-form-field>
        <mat-label>Question Type</mat-label>
        <mat-select formControlName="type">
            <mat-option [value]="QuestionType.MULTIPLE_CHOICE">Multiple Choice</mat-option>
            <mat-option [value]="QuestionType.MULTIPLE_SELECT">Multiple Select</mat-option>
            <mat-option [value]="QuestionType.SHORT_FORM">Short Form</mat-option>
            <mat-option [value]="QuestionType.LONG_FORM">Long Form</mat-option>
            <mat-option [value]="QuestionType.LIKERT">Likert (Linear Scale)</mat-option>
        </mat-select>
    </mat-form-field>

    <h3>Question Videos</h3>

    <p *ngIf="videos.controls.length == 0">No Videos</p>

    <div formArrayName="videos" fxLayout="column" fxLayoutGap="0.5rem">

        <div *ngFor="let videoControl of videos.controls; let videoIndex = index" fxLayout="row" fxLayoutGap="1rem" fxLayoutAlign="start center">

            <mat-form-field>
                <mat-label>Video URL</mat-label>
                <input [formControlName]="videoIndex" name="url" matInput placeholder="Video URL" required placeholder="e.g. https://vimeo.com/video/12345">
            </mat-form-field>

            <mat-icon color="warn" (click)="removeQuestionVideo(videoIndex)" style="cursor: pointer;" matTooltip="Remove Video">delete</mat-icon>

        </div>

        <div fxLayoutAlign="center">
            <button mat-stroked-button (click)="addQuestionVideo()" type="button" type="button" color="primary">
            <mat-icon>add</mat-icon> Add Video
        </button>
        </div>

    </div>

    <ng-container *ngIf="[QuestionType.MULTIPLE_CHOICE, QuestionType.MULTIPLE_SELECT].includes(questionFormGroup.get('type').value)">

        <h3>Options</h3>
        <div formArrayName="options" fxLayout="column" fxLayoutGap="0.5rem">

            <div [formGroupName]="optionIndex" *ngFor="let optionGroup of options.controls; let optionIndex = index" fxLayout="row" fxLayoutGap="1rem" fxLayoutAlign="start center">

                <mat-form-field>
                    <mat-label>Option {{optionIndex + 1}}</mat-label>
                    <input formControlName="value" name="value" matInput required>
                </mat-form-field>

                <mat-radio-group *ngIf="moduleType == ModuleType.TEST && questionFormGroup.get('type').value == QuestionType.MULTIPLE_CHOICE" [ngClass]="{'invalid': !pageGroup.get('question.hasAnswer').value }">
                    <mat-radio-button [checked]="optionGroup.get('checked').value" [value]="optionIndex" (change)="onQuestionCorrectRadioChange(optionIndex)" color="primary">Correct</mat-radio-button>
                </mat-radio-group>

                <mat-checkbox formControlName="checked" *ngIf="moduleType == ModuleType.TEST && questionFormGroup.get('type').value == QuestionType.MULTIPLE_SELECT" (change)="onQuestionCorrectCheckChange()" [ngClass]="{'invalid': !pageGroup.get('question.hasAnswer').value }"
                    color="primary">Correct</mat-checkbox>

                <mat-icon color="warn" (click)="removeOption(optionIndex)" [ngStyle]="{'cursor': optionIndex != 0 ? 'pointer' : 'inherit', 'color': optionIndex == 0 ? 'transparent' : null}" [matTooltip]="optionIndex != 0 ? 'Remove Option' : ''">delete</mat-icon>

            </div>

            <div fxLayoutAlign="center">
                <button mat-stroked-button (click)="addOption()" type="button" color="primary">
                <mat-icon>add</mat-icon> Add Option
            </button>
            </div>

        </div>

    </ng-container>

    <ng-container *ngIf="questionFormGroup.get('type').value == QuestionType.LIKERT">

        <h3>Settings</h3>

        <mat-form-field>
            <mat-label>Scale Length</mat-label>
            <mat-select formControlName="scaleLength">
                <mat-option *ngFor="let i of ScaleLengths" [value]="i">{{i}}</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Show Numbers</mat-label>
            <mat-select formControlName="scaleShowNumbers">
                <mat-option [value]="true">Yes</mat-option>
                <mat-option [value]="false">No</mat-option>
            </mat-select>
        </mat-form-field>

        <h3>
            Scales
        </h3>

        <div fxLayout="row" fxLayoutGap="1rem" *ngIf="scales.controls.length > 1">
            <div fxFlex></div>
            <mat-form-field fxFlex>
                <mat-label>
                    Default Start Label (Optional)
                </mat-label>
                <input matInput formControlName="defaultMinLabel" (keyup)="onDefaultLabelChange()">
            </mat-form-field>
            <mat-form-field fxFlex>
                <mat-label>
                    Default End Label (Optional)
                </mat-label>
                <input matInput formControlName="defaultMaxLabel" (keyup)="onDefaultLabelChange()">
            </mat-form-field>
            <button mat-icon-button style="color: transparent;" fxFlex="nogrow">
            <mat-icon>delete</mat-icon>
        </button>
        </div>

        <div formArrayName="scales">

            <div [formGroupName]="scaleIndex" fxLayout="row" fxLayoutGap="1rem" *ngFor="let labelGroup of scales.controls; let scaleIndex = index">

                <mat-form-field>
                    <mat-label>
                        Scale Label {{!(pageGroup.get('question.defaultMinLabel').value || pageGroup.get('question.defaultMaxLabel').value) ? '(Optional)' : '' }}
                    </mat-label>
                    <input matInput formControlName="scaleLabel">
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Start Label</mat-label>
                    <input matInput formControlName="minLabel">
                </mat-form-field>
                <mat-form-field>
                    <mat-label>End Label</mat-label>
                    <input matInput formControlName="maxLabel">
                </mat-form-field>
                <button mat-icon-button [ngStyle]="{color: scaleIndex < 1 && 'transparent'}" [color]="scaleIndex > 0 && 'warn'" (click)="scaleIndex > 0 && removeQuestionScale(scaleIndex)">
                <mat-icon>delete</mat-icon>
            </button>

            </div>

        </div>

        <div fxLayoutAlign="center">
            <button mat-stroked-button type="button" color="primary" (click)="addQuestionScale()">
            <mat-icon>add</mat-icon> Add Scale
        </button>
        </div>

    </ng-container>

    <h3>Feedback</h3>

    <mat-form-field>
        <mat-label>Feedback Type</mat-label>
        <mat-select formControlName="feedbackType" (selectionChange)="onQuestionFeedbackTypeChange()">
            <mat-option [value]="FeedbackType.NONE">None</mat-option>
            <mat-option [value]="FeedbackType.CORRECT" *ngIf="moduleType == ModuleType.TEST && (questionFormGroup.get('type').value == QuestionType.MULTIPLE_CHOICE || questionFormGroup.get('type').value == QuestionType.MULTIPLE_SELECT)">Incorrect/Correct</mat-option>
            <mat-option [value]="FeedbackType.OPTION" *ngIf="questionFormGroup.get('type').value == QuestionType.MULTIPLE_CHOICE">By Option</mat-option>
            <mat-option [value]="FeedbackType.DEFAULT">Default Text/Video</mat-option>
        </mat-select>
    </mat-form-field>

    <div formArrayName="feedbacks" *ngIf="feedbacks.controls.length != 0">

        <div [formGroupName]="feedbackIndex" *ngFor="let feedbackGroup of feedbacks.controls; let feedbackIndex = index" fxLayout="column" fxLayoutGap="0.5rem">

            <div *ngIf="feedbackType == FeedbackType.DEFAULT">
                <h4 style="margin:0">Feedback for All Responses</h4>
            </div>

            <div *ngIf="feedbackType == FeedbackType.OPTION">
                <h4 style="margin:0">Feedback for Option {{feedbackIndex + 1}}</h4>
            </div>

            <div *ngIf="feedbackType == FeedbackType.CORRECT && feedbackIndex == 0">
                <h4 style="margin:0">Feedback for Correct Answer</h4>
            </div>

            <div *ngIf="feedbackType == FeedbackType.CORRECT && feedbackIndex == 1">
                <h4 style="margin:0">Feedback for Incorrect Answers</h4>
            </div>

            <div *ngFor="let content of feedbackGroup['controls']['contents']['controls']; let contentIndex = index">

                <div formArrayName="contents" *ngIf="content.controls.type.value == ContentType.TEXT" fxLayoutGap="1rem" fxLayoutAlign="start center">
                    <mat-form-field [formGroupName]="contentIndex">
                        <mat-label>Text</mat-label>
                        <input formControlName="value" name="text" matInput required>
                    </mat-form-field>
                    <mat-icon color="warn" [ngStyle]="{'color': contentIndex == 0 ? 'transparent' : null, 'cursor': contentIndex == 0 ? 'inherit' : 'pointer'}" (click)="removeFeedbackContent(feedbackIndex, contentIndex)">delete</mat-icon>
                </div>

                <div formArrayName="contents" *ngIf="content.controls.type.value == ContentType.VIDEO" fxLayoutGap="1rem" fxLayoutAlign="start center">
                    <mat-form-field [formGroupName]="contentIndex">
                        <mat-label>Video URL</mat-label>
                        <input formControlName="value" matInput placeholder="e.g. https://vimeo.com/video/12345" required>
                    </mat-form-field>
                    <mat-icon color="warn" [ngStyle]="{'color': contentIndex == 0 ? 'transparent' : null, 'cursor': contentIndex == 0 ? 'inherit' : 'pointer'}" (click)="removeFeedbackContent(feedbackIndex, contentIndex)">delete</mat-icon>
                </div>

                <div formArrayName="contents" *ngIf="content.controls.type.value == ContentType.IMAGE">

                    <div fxLayoutGap="1rem" fxLayoutAlign="start center" *ngIf="content.controls.value.value == ''">
                        <mat-form-field [formGroupName]="contentIndex" (click)="fileInput.click()">
                            <mat-label>Image/GIF</mat-label>
                            <input formControlName="value" matInput required readonly>
                        </mat-form-field>
                        <mat-icon color="warn" [ngStyle]="{'color': contentIndex == 0 ? 'transparent' : null, 'cursor': contentIndex == 0 ? 'inherit' : 'pointer'}" (click)="removeFeedbackContent(feedbackIndex, contentIndex)">delete</mat-icon>
                    </div>

                    <input type="file" hidden (change)="onFeedbackImageChange(feedbackIndex, contentIndex, $event)" accept="image/*" #fileInput>

                    <div *ngIf="feedbackImageFiles[feedbackIndex][contentIndex].src != ''" fxLayout="column" class="coverPhoto" fxLayoutAlign="start start">
                        <label>
                        Image/GIF
                    </label>
                        <mat-card fxFlex="none" style="padding:0.5rem">
                            <mat-card-content style="margin-bottom: 0;">
                                <img [src]="feedbackImageFiles[feedbackIndex][contentIndex].src" style="cursor: pointer;height:200px" (click)="fileInput.click()">
                            </mat-card-content>
                            <mat-card-actions fxLayoutAlign="center">
                                <button mat-button mat-icon-button matTooltip="Change" color="primary" matTooltip="edit" type="button" (click)="fileInput.click()">
                                <mat-icon>edit</mat-icon>
                            </button>
                                <button mat-button mat-icon-button matTooltip="Change" color="warn" matTooltip="remove" type="button" (click)="removeFeedbackImage(feedbackIndex, contentIndex)">
                                <mat-icon>delete</mat-icon>
                            </button>
                            </mat-card-actions>
                        </mat-card>
                    </div>

                </div>

            </div>

            <div fxLayoutAlign="center" fxLayoutGap="1rem">
                <button mat-stroked-button (click)="addFeedbackContent(feedbackIndex, ContentType.IMAGE)" type="button" color="primary"> <mat-icon>add</mat-icon> Add Image</button>
                <button mat-stroked-button (click)="addFeedbackContent(feedbackIndex, ContentType.VIDEO)" type="button" color="primary"> <mat-icon>add</mat-icon> Add Video</button>
            </div>

        </div>

    </div>

</div>